module.exports = __webpack_public_path__ + "static/media/reading.a41067ea.svg";